import React from 'react';
import { changeFormat } from 'infrastructure/functions';
import { DateFormats } from 'infrastructure/enums';

import s from './styles.module.scss';

import type { DateString } from 'infrastructure/types';

interface IDateBlockProps {
  date: DateString;
}

const DateBlock: React.FC<IDateBlockProps> = (props) => {
  const { date } = props;
  return (
    <div className={s['date-block']}>
      {changeFormat(
        date,
        DateFormats['MMM dd, yyyy'],
        DateFormats['MM/dd/yyyy'],
      )}
    </div>
  );
};

export default DateBlock;
